<template>
    <el-dialog title="同步旧版数据" :visible="isShow" width="70%" :before-close="close">
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="旧版学校ID">
                    <el-input v-model="formInline.schoolid" placeholder="旧版学校ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>

        </div>
        <div>
            <p>学校名称： {{this.schoolname}}</p>
            <p>最后同步时间： {{this.last_sync_date}}</p>
            <p>旧版最后备份时间：{{this.last_back_date}}</p>
        </div>
        <el-table  v-loading="loading" :data="list" width="100%" >
            <el-table-column prop="FAutoId" label="序号" width="380"></el-table-column>
            <el-table-column prop="FName" label="方案名称" width="380"></el-table-column>
            <el-table-column prop="FmTime" label="创建时间" width="380"></el-table-column>
        </el-table>
        <el-row v-if="page">
            <pagination2 :link-page="page" :enableEvent="true" @change="watchPage"></pagination2>
        </el-row>
        <div style="margin-left: 550px;margin-top: 20px">
            <el-button type="primary" @click="migrateOldData">同步</el-button>
            <el-button  type="info" @click="close">取消</el-button>
        </div>

    </el-dialog>
</template>

<style>
    body {
        margin: 0;
    }
</style>

<script>


    import Pagination2 from "~/widgets/Pagination.vue";
    import AccountService from "~/services/CustomerAccounts";


    export default {
        name: "PaikeData",
        components: {
            Pagination2
        },
        props: {
            display: {
                type: Boolean,
                default: false
            },
            schoolId: {
                required:false
            }

        },
        watch: {
            display: function (value, origin) {
                this.isShow = value;
            }
        },
        data() {
            return {
                formInline: {
                    schoolid: '',
                },
               // schoolId:'',
                isShow: false,
                list: [],
                last_back_date:'',
                schoolname:'',
                last_sync_date:'',
                page: null,
                customer_id: this.$route.query['id'],
                searchModel: {
                    schoolid: '',
                    perPage: 20,
                    page: 1
                },
                loading: false
            }
        },
        created() {
            this.isShow = this.display;

        },
        methods: {
            /**
             * 迁移旧数据
             **/
            migrateOldData() {

                this.$confirm("确定要同步旧数据吗？同步后无法撤销，请确保旧数据学校和新学校是否为相同学校", "温馨提示", {type: "warning"}).then(ok => {  this.loading=true
                    AccountService.migrateOlddata(this.schoolId, this.formInline.schoolid).then(res => {
                        if (res.code == 0) {
                            AccountService.syncTime(this.formInline.schoolid).then(res => {
                                if (res.code == 0) {
                                    if(res.msg == ''){
                                        this.$confirm('同步成功', '提示', {
                                            confirmButtonText: '确定',
                                            cancelButtonText: '取消',
                                            type: 'success'
                                        })
                                       /* this.$message({
                                            message: '同步成功！',
                                            type: 'success'
                                        });*/
                                    }else{
                                        this.$confirm(res.msg, '提示', {
                                            confirmButtonText: '确定',
                                            cancelButtonText: '取消',
                                            type: 'error'
                                        })
                                        /*this.$message({
                                            message: res.msg,
                                            type: 'error'
                                        });*/
                                    }
                                    this.loading=false

                                }

                            })
                        }else{
                            this.loading=false
                        }

                    });
                }).catch(cancel => {
                    return false;
                });



            },

            onSubmit() {
                this.loading=true
                this.searchModel.schoolId = this.formInline.schoolid;
                this.getList(this.searchModel);
            },

            getList(params) {
                AccountService.getSolutions(params).then(res => {
                    if  (res && res.code == 0) {
                        this.loading=false
                        this.list = res.data.list;
                        this.last_back_date = res.data.last_back_date;
                        this.last_sync_date = res.data.last_sync_date;
                        this.schoolname = res.data.schoolname

                        if(res.msg !=''){
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                        if (res._meta) {
                            this.page = res._meta;
                        }
                    }
                })
            },

            close(status = false) {
                this.isShow = false;
                this.$emit("callback", status);
            },

            watchPage(pageParams) {
                this.searchModel['page'] = pageParams["page"];
                this.searchModel['perPage'] = pageParams["perPage"];
                this.getList(this.searchModel);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/dialog/PaikeData.vue